import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { id: "gallery", label: "Gallery" },
  { id: "about", label: "About" },
  { id: "amenities", label: "Amenities" },
  { id: "location", label: "Location" },
  { id: "owners", label: "Hosts" },
  { id: "reviews", label: "Reviews" },
  { id: "inquire", label: "Inquire" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#FAF7F2]/85 backdrop-blur-xl border-b border-[#EAE0D5]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-16 flex items-center justify-between">
        <button
          onClick={() => handleNav("hero")}
          data-testid="header-logo"
          className={`font-serif-display text-lg md:text-xl tracking-tight transition-colors ${
            scrolled ? "text-[#232E26]" : "text-white drop-shadow"
          }`}
        >
          Mirabella <span className="italic">Anemoessa</span>
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => handleNav(l.id)}
              className={`text-sm tracking-wide transition-colors hover:text-[#C65D47] ${
                scrolled ? "text-[#232E26]" : "text-white/95"
              }`}
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="header-cta"
            onClick={() => handleNav("inquire")}
            className="btn-terra text-sm px-5 py-2 rounded-sm"
          >
            Check availability
          </button>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className={`md:hidden p-2 ${
            scrolled ? "text-[#232E26]" : "text-white"
          }`}
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-[#FAF7F2] border-t border-[#EAE0D5]"
        >
          <div className="px-6 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <button
                key={l.id}
                data-testid={`mobile-nav-${l.id}`}
                onClick={() => handleNav(l.id)}
                className="text-left py-2 text-[#232E26] hover:text-[#C65D47]"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="mobile-header-cta"
              onClick={() => handleNav("inquire")}
              className="btn-terra mt-2 px-5 py-3 rounded-sm text-sm self-start"
            >
              Check availability
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
